import e from "./Autocomplete.vue_rollup-plugin-vue=script.js";
export default (function (e, t, n, r, i, s, u, c) {
  var o = ("function" == typeof n ? n.options : n) || {};
  return o.__file = "Autocomplete.vue", o.render || (o.render = e.render, o.staticRenderFns = e.staticRenderFns, o._compiled = !0, i && (o.functional = !0)), o._scopeId = r, o;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: e.suit()
    }, [e._t("default", function () {
      return [n("p", [e._v("\n      This widget doesn't render anything without a filled in default slot.\n    ")]), e._v(" "), n("p", [e._v("query, function to refine and results are provided.")]), e._v(" "), n("pre", [e._v("refine: Function")]), e._v(" "), n("pre", [e._v('currentRefinement: "' + e._s(e.state.currentRefinement) + '"')]), e._v(" "), n("details", [e._m(0), e._v(" "), n("pre", [e._v(e._s(e.state.indices))])])];
    }, {
      refine: e.state.refine,
      currentRefinement: e.state.currentRefinement,
      indices: e.state.indices
    })], 2) : e._e();
  },
  staticRenderFns: [function () {
    var e = this.$createElement,
        t = this._self._c || e;
    return t("summary", [t("code", [this._v("indices")]), this._v(":")]);
  }]
}, 0, e, void 0, !1);